define('social/social',['require','exports','module','jquery','jquery.bindable/jquery.bindable','facebook/fb','bam.url/url','bitly/bitly','client/client'],function( require, exports, module ) {
    var $ = require("jquery");
    var bindable  = require("jquery.bindable/jquery.bindable");
    var socialFb  = require('facebook/fb');
    var urlModule = require('bam.url/url');
    var bitly     = require('bitly/bitly');
    var client     = require('client/client');
    
  
     var module = {},
        
        firstload = true,
        
        fblike_frames = [],

        pt_api_loaded = false,

        f,

        t,
        
        twttrDef = function() {
           
                return  $.ajax({
                   dataType: "script",
                   url: "https://platform.twitter.com/widgets.js",
                   async: false,
                   cache: true
                });
        },

        twfollow_frames = [],

        queue = [],

        main_dfd = $.Deferred(),

        df_queue = [(function () {
            return main_dfd.promise()
        })()],

        pageload = true,

        current_resolved = 0,

        gp_api_loaded = false,

        iframes_dfd = $.Deferred(),

        gp_dfd = $.Deferred(),
        
        

        _eventFire = function (element, event) {
            if (document.createEventObject) {
                // dispatch for IE
                var evt = document.createEventObject();
                return element.fireEvent('on' + event, evt)
            } else {
                // dispatch for firefox + others
                var evt = document.createEvent("HTMLEvents");
                evt.initEvent(event, true, true); // event type,bubbling,cancelable
                return !element.dispatchEvent(evt);
            }
        },

        /**
         * reset deferred queue related variables,
         * @param {Object} deferred object
         */
        _resetVars = function () {
            twfollow_frames = [];
            fblike_frames = [];
            queue = [];
            main_dfd = $.Deferred();
            df_queue = [(function () {
                return main_dfd.promise()
            })()];
            current_resolved = 0;
        },

        /**
         * Check if all deferreds resolved,
         * reslove main deferred and load frames
         * @param {Object} deferred object
         */
        _dfCheck = function (dfObj) {
            dfObj.resolve();
            current_resolved++
            if (current_resolved + 1 === df_queue.length) {
                main_dfd.resolve();
            }
        },

        /**
         * Opens a JS window
         * @param {String} url
         * @param {Object} cfg window properties
         */
        _pop = function (url, cfg) {
            cfg = $.extend({
                width: 800,
                height: 400,
                scrollbars: 1,
                menubar: 0,
                toolbar: 0,
                location: 0,
                status: 0,
                resizable: 1
            }, cfg);

            cfg.left = cfg.left || (screen.width / 2 - cfg.width / 2);
            cfg.top = cfg.top || (screen.height / 2 - cfg.height / 1.5);
            
         
            if (client.isWindowsPhone) {
              window.location(url);
            } else {
              window.open(url, "bamshare", $.param(cfg).replace(/&/g, ","));
            }
            
        },
        
        _isIEVersion = function() {
            var myNav = navigator.userAgent.toLowerCase();
            return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
        },
        
        _addTweetTracking = function(obj,omnitureTracking) {
          
          var omnitureVars = obj.attr("data-omniture");
          
          if (omnitureVars) {
            return false;
          }
          
          obj.attr("data-omniture", JSON.stringify(omnitureTracking));          
          
        },

        /**
         * appends params to a query string
         * @param {String} url
         * @param {Object|String} extraParams key value pairs to append to the query
         * @return {String} the resulting query string
         */
        _appendQuery = function (url, extraParams) {
            if (typeof url !== "string" || !extraParams) {
                return;
            }

            var joiner;

            if (typeof extra !== "string") {
                extraParams = $.param(extraParams);
            }

            if (url.indexOf("%3A" /* encodeURIComponent(":") */ ) > -1) { // url has been encoded (assuming http:// is present)
                joiner = url.indexOf("%3F" /* encodeURIComponent("?") */ ) > -1 ? "%26" /* encodeURIComponent("&") */ : "%3F" /* encodeURIComponent("?") */ ;
                extraParams = encodeURIComponent(extraParams);
            } else {
                joiner = url.indexOf("?") > -1 ? "&" : "?";
            }
            return url + joiner + extraParams;
        },

        $doc = $(document);


    var Social = function (cfg) {
        this.cfg = $.extend({
            container: "",
            url: document.location.href,
            title: document.title,
            tracking: undefined,
            showCounters: false,
            sequenceloading: true,
            manuallyloading: false,
            shorty: false,
            disableCount:false
        }, cfg);
    };

    Social.prototype = {
        _services: {
            email: {
                cfg: (function () {


                    return {
                        tracking: {},
                        type: undefined,
                        params: urlModule.parseQueryParameters(),
                        shorty: false,
                        email_params: {
                            "news": ["content_id", "vkey"],
                            "media": ["content_id", "metaId", "title", "blurb"],
                            "photos": ["content_id", "metaId", "title", "c_id"],
                            "social/hitpix": ["photoid", "c_id", "blast", "title"],
                            "photos/player": ["player_id", "title"]
                        }
                    };
                }()),
                getUrl: function (svc_cfg) {
                    var out = "",
                        email_params, params = {};
                    if ((this instanceof Social) && svc_cfg.type && (svc_cfg.type in svc_cfg.email_params)) {
                        out = "/" + svc_cfg.type + "/email/send.jsp?";
                        email_params = svc_cfg.email_params[svc_cfg.type];

                        for (var i = 0, n = email_params.length; i < n; i++) {
                            var val;
                            switch (email_params[i]) {
                            case "metaId":
                                val = svc_cfg.params.content_id;
                                break;
                            case "title":
                                val = this.cfg.title;
                                break;
                            case "blurb":
                                val = this.cfg.blurb;
                                break;
                            default:
                                val = svc_cfg.params[email_params[i]];
                            }
                            params[email_params[i]] = val;
                        }
                    }
                    return (out + $.param(params)) || false;
                },

                dfd: $.Deferred(),

                pop_cfg: {
                    height: 470,
                    width: 500,
                    status: 1
                }
            },
            facebook: {
                cfg: {
                    tracking: {
                        tcid: "fb_share"
                    },
                    layout: undefined || "button_count",
                    action: undefined || "recommend",
                    showface: undefined || false,
                    type: undefined || "share",
                    popWidth: undefined || 980,
                    popHeight: undefined || 300,
                    isFBML: undefined || false,
                    shorty: true,
                    ref: undefined || "fb_share",
                    countPosition: undefined || "outside",
                    title: undefined,
                    disableCount:false,
                    showCounters: undefined || false
                },

                dfd: $.Deferred(),

                getUrl: function (svc_cfg) {
                    var fburl = (client.isDesktop) ? "http://www.facebook.com" : "http://m.facebook.com";
                    var title = (svc_cfg.title) ? svc_cfg.title : this.cfg.title;
                    return (this instanceof Social) && (svc_cfg.type === "share") ? fburl + "/sharer.php" + "?u=" + encodeURIComponent(this._getUrlWithTracking(svc_cfg)) + "&t=" + encodeURIComponent(title) : "#";
                },
                pop_cfg: {
                    height: 450,
                    width: 980,
                    scrollbars: 0
                },

                callafter: {
                    "share": function (options) {
                        var cTarget = (options['svc_cfg'].countPosition && options['svc_cfg'].countPosition === 'inside') ? $(options.target) : $(options.target).parent();                        
                        cTarget.append("<span class='share_count'><div>" + ((options.count && options.count > 0) ? options.count : 0) + "</div></span>");
                        
                    },

                    "like": function (options) {

                        df_queue.push((function () {
                            return options.parent._services.twitter.dfd.promise();
                        })());

                        var config = options.svc_cfg,
                            layout = config.layout,
                            action = config.action,
                            width = (config.width) ? config.width : ((layout !== 'standard') ? ((layout === 'box_count') ? 55 : 150) : 450);
                        height = (layout !== 'button_count') ? 90 : 20;

                        $.extend(options, {
                            width: width,
                            height: height
                        });

                        fblike_frames.push(options);


                        if (options.parent.cfg.sequenceloading !== false) {
                            $(function () {

                                for (f = 0; f < fblike_frames.length; f++) {
                                    socialFb.iframes.like(fblike_frames[f]);
                                }

                                if (!config.isFBML && $.inArray("iframe.fb-like", queue) === -1) {
                                    queue.push("iframe.fb-like");
                                }

                                _dfCheck(options.parent._services.facebook.dfd);
                            })
                        } else {

                            socialFb.iframes.like(options);
                        }


                    }
                },


                getCount: {
                    share: function (cb, svc_cfg, target) {
                        if(!svc_cfg.disableCount) {
                        var url = this._getUrlWithTracking(svc_cfg),
                            that = this;

                        $.ajax({
                            dataType: "jsonp",
                            url: "https://graph.facebook.com/",
                            data: {
                                id: svc_cfg.ourl
                            },
                            jsonp: "callback",
                            timeout: 3000,
                            success: function (response) {
                                cb({
                                    target: target,
                                    svc_cfg: svc_cfg,
                                    url: url,
                                    count: response.shares,
                                    parent: that
                                }); // response[0].total_count
                            }
                        });
                        }
                    },

                    like: function (cb, svc_cfg, target) {
                        var url = this._getUrlWithTracking(svc_cfg);
                        cb({
                            target: target,
                            svc_cfg: svc_cfg,
                            url: url,
                            parent: this
                        });
                    }

                }

            },
            google: {
                cfg: {
                    tracking: {
                        tcid: "gp_share"
                    },
                    type: undefined || "plusone",
                    annotation: undefined || "bubble",
                    size: undefined || "medium",
                    width: undefined || "80px",
                    shorty: false,
                    omniture: undefined || "",
                    disableCount:false,
                    showCounters: undefined || false,
                    callback: undefined ||
                        function () {}
                },

                dfd: $.Deferred(),

                callafter: {
                    "share": function (options) {
                        var cTarget = (options['svc_cfg'].countPosition && options['svc_cfg'].countPosition === 'inside') ? $(options.target) : $(options.target).parent();
                        cTarget.append("<span class='share_count'><div>" + ((options.count && options.count > 0) ? options.count : 0) + "</div></span>");

                    },
                    "plusone": function (options) {

                        var container = $(options.target);
                        var max = 100000;
                        var min = 1;
                        var random = Math.floor(Math.random() * (max - min + 1)) + min;


                        container.html('<div class="g-plusone-paused" id="gp-btn-' + random + '" data-omniture=\'' + JSON.stringify(options.svc_cfg.omniture) + '\' data-width="' + options.svc_cfg.width + '" data-size="' + options.svc_cfg.size + '" data-annotation="' + options.svc_cfg.annotation + '" data-href="' + options.parent._getUrlWithTracking(options.svc_cfg) + '"></div>');


                        if (!options.parent.cfg.sequenceloading && typeof gapi !== 'undefined') {
                            loadGooglePlusOne($("#gp-btn-" + random));

                        }


                        if (!gp_api_loaded) {
                            gp_api_loaded = true;
                            $.ajax({
                                url: "https://apis.google.com/js/plusone.js",
                                dataType: "script",
                                type: "GET",
                                data: {
                                    parsetags: "explicit"
                                },
                                success: function () {
                                    gp_dfd.resolve();

                                    // this is test code
                                    if (!options.parent.sequenceloading && typeof gapi !== 'undefined') {
                                        $(".g-plusone-paused").each(function () {
                                            var gp = $(this),
                                                par = gp.parent();

                                            if (par.find("iframe").length === 0) {
                                                loadGooglePlusOne(gp);

                                            }
                                        });
                                    }

                                }
                            });
                        }

                    }
                },
                getUrl: function (svc_cfg) {
                    var gpurl = "https://plus.google.com";
                    return (this instanceof Social) && (svc_cfg.type === "share") ? gpurl + "/share" + "?url=" + encodeURIComponent(this._getUrlWithTracking(svc_cfg)) : "#";
                },
                pop_cfg: {
                    height: 300,
                    width: 700,
                    scrollbars: 0
                },
                getCount: {
                    "share": function (cb, svc_cfg, target) {
                       
                        var makeCall = (_isIEVersion() && _isIEVersion() < 10) ? false : true;
                        
                                            
                        if (makeCall && !svc_cfg.disableCount) {
                        
                        var that = this;
                        var data = {
                            "params": {
                                "nolog": true,
                                "id": this._getUrlWithTracking(svc_cfg),
                                "source": "widget",
                                "userId": "@viewer",
                                "groupId": "@self"
                            },
                            "jsonrpc": "2.0",
                            "key": "p",
                            "apiVersion": "v1",
                            "method": "pos.plusones.get",
                            "id": "p",
                        };

                        $.ajax({
                            url: "https://clients6.google.com/rpc",
                            type: "POST",
                            data: JSON.stringify(data),
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            success: function (res) {
                                
                                cb({
                                    target: target,
                                    svc_cfg: svc_cfg,
                                    count: res.result.metadata.globalCounts.count,
                                    parent: that
                                }); 
                                
                            },
                            error: function (err) {
                                console.log(err)
                            }
                        });
                        
                        }


                    },
                    "plusone": function (cb, svc_cfg, target) {
                        var url = this._getUrlWithTracking(svc_cfg),
                            that = this;
                        cb({
                            target: target,
                            svc_cfg: svc_cfg,
                            parent: that
                        });
                    }
                }
            },
            pinterest: {
                cfg: {
                    tracking: {
                        tcid: "pt_share"
                    },
                    type: undefined || "default",
                    shorty: false,
                    layout: undefined || "horizontal",
                    loadapi: false,
                    title: undefined
                },

                callafter: {
                "default": function(options) {

                  var container = $(options.target);
                  var title = (options.svc_cfg.title) ? options.svc_cfg.title : options.parent.cfg.title;
                  
                   container.html('<a href="http://pinterest.com/pin/create/button/?url='+encodeURIComponent(options.parent.cfg.url)+'&media='+encodeURIComponent(options.svc_cfg.image)+'&description='+encodeURIComponent(title)+'" class="pin-it-button" count-layout="'+options.svc_cfg.layout+'"></a>');

              if (!pt_api_loaded || options.svc_cfg.loadapi) {

                 pt_api_loaded = true;
                 
                 if (typeof build_pinterest_button !== 'undefined') {
                   build_pinterest_button(container[0]);
                   return false;
                 }

               
                
                  (function(d){
                  var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
                  p.type = 'text/javascript';
                  p.async = true;
                  p['data-pin-build'] = 'build_pinterest_button';
                  p.src = '//assets.pinterest.com/js/pinit.js';
                  f.parentNode.insertBefore(p, f);
                 }(document));
                
                


              }
           }
        },

                getUrl: function (svc_cfg) {

                },

                pop_cfg: {
                    height: 300,
                    width: 700,
                    scrollbars: 0
                },

                getCount: {

                    "default": function (cb, svc_cfg, target) {
                        var that = this;

                        that.cfg.url = that._getUrlWithTracking(svc_cfg);

                        cb({
                            target: target,
                            svc_cfg: svc_cfg,
                            parent: that
                        });
                    }
                }

            },
            twitter: {
                cfg: {
                    tracking: {
                        tcid: "tw_share"
                    },
                    text: undefined,
                    via: undefined,
                    shorty: true,
                    hashtags: undefined,
                    type: undefined || "default",
                    related: undefined,
                    tweetTracking: undefined,
                    counturl: undefined,
                    showCounters: undefined || false,
                    countPosition: undefined || "outside",
                    title: undefined,
                    disableCount:false
                },

                dfd: $.Deferred(),

                callafter: {

                    "default": function (options) {
                        var cTarget = (options.scfg.countPosition && options.scfg.countPosition === 'inside') ? $(options.target) : $(options.target).parent();
                        
                        cTarget.append("<span class='share_count'><div>" + ((options.count && options.count > 0) ? options.count : 0) + "</div></span>");
                        
                    },

                    "follow": function (options) {
                        twfollow_frames.push(options);

                        df_queue.push((function () {
                            return options.parent._services.twitter.dfd.promise();
                        })());

                        var width = (options.svc_cfg.via.split("").length > 5) ? '125px' : '100px';

                        if (options.svc_cfg.width) {
                            width = options.svc_cfg.width; + 'px';
                        }

                        $(function () {
                            for (t = 0; t < twfollow_frames.length; t++) {

                                $(options.target).html('<iframe class="tweet-follow" allowtransparency="true" frameborder="0" scrolling="no" data-url="http://platform.twitter.com/widgets/follow_button.html?screen_name=' + options.svc_cfg.via + '&show_count=' + options.svc_cfg.showCounters + '"  style="width:' + width + '; height:20px;"></iframe>');
                            }

                            if ($.inArray("iframe.tweet-follow", queue) === -1) {
                                queue.push("iframe.tweet-follow");
                            }

                            _dfCheck(options.parent._services.twitter.dfd);
                        });
                    }
                },
                getUrl: function (svc_cfg) {

                    var url = (!svc_cfg.tracking) ? svc_cfg.ourl : this._getUrlWithTracking(svc_cfg),
                        counturl = (!svc_cfg.tracking) ? svc_cfg.counturl : svc_cfg.urltracking,
                        that = this,
                        title = (svc_cfg.title) ? svc_cfg.title : that.cfg.title;

                    return "/sections/redirector/bower_components/twitter-redirector/twitter-redirect.html?url="+ encodeURIComponent(url)+ "&text=" + encodeURIComponent(svc_cfg.text || this.cfg.title) + (svc_cfg.via ? "&via=" + svc_cfg.via : "") + ((svc_cfg.related && svc_cfg.related.split(":")[0] !== svc_cfg.via) ? "&related=" + svc_cfg.related : "" + (svc_cfg.hashtags ? "&hashtags=" + svc_cfg.hashtags : ""));


                },
                pop_cfg: {
                    height: 300,
                    width: 700,
                    scrollbars: 0
                },
                getCount: {
                    "default": function (cb, svc_cfg, target) {
                     
                        if (!svc_cfg.disableCount) {
                        var that = this;
                        $.ajax({
                            dataType: "jsonp",
                            url: window.location.protocol + "//cdn.api.twitter.com/1/urls/count.json",
                            data: {
                                url: (!svc_cfg.tracking) ? svc_cfg.counturl : svc_cfg.urltracking,
                                mode: "preview"
                            },
                            success: function (response) {
                                cb({
                                    count: response.count,
                                    target: target,
                                    parent: that,
                                    scfg: svc_cfg
                                });
                            }
                        });
                        }
                    },

                    "follow": function (cb, svc_cfg, target) {
                        var url = this._getUrlWithTracking(svc_cfg),
                            that = this;
                        cb({
                            target: target,
                            svc_cfg: svc_cfg,
                            parent: that
                        });
                    }
                }
            },
            reddit: {
                cfg: {
                    tracking: {
                        tcid: "reddit_share"
                    },
                    shorty: false,
                    type: undefined || "default",
                    title: undefined
                },


                callafter: {

                    "default": function (options) {
                        
                        $("<span class='share_count'><div /></span>").find("div").text(options.count).end().insertAfter(options.target);

                    }

                },


                getUrl: function (svc_cfg) {
                    return (this instanceof Social) && "http://www.reddit.com/submit" + "?url=" + encodeURIComponent(this._getUrlWithTracking(svc_cfg));
                },

                pop_cfg: {
                    height: 300,
                    width: 700,
                    scrollbars: 0
                },

                getCount: {

                    "default": function (cb, svc_cfg, target) {
                        var that = this;
                       
                       

                       $.ajax({
                        url: "/delegator/http://www.reddit.com/api/info.json",
                        data: {
                            url: that._getUrlWithTracking(svc_cfg)
                        },
                        timeout: 3000,
                        dataType: "json",
                        success: function (response) {
                             
                             cb({
                                count: (response.data.children.length > 0) ? response.data.children[0].data.score : 0,
                                target: target,
                                parent: that
                             });
                        }
                       });

                    }

                }
            },
            digg: {
                cfg: {
                    tracking: {
                        tcid: "dg_share"
                    },
                    shorty: false,
                    title: undefined
                },

                dfd: $.Deferred(),

                getUrl: function (svc_cfg) {
                    var title = (svc_cfg.title) ? svc_cfg.title : this.cfg.title;
                    return (this instanceof Social) && "http://digg.com/submit" + "?url=" + encodeURIComponent(this._getUrlWithTracking(svc_cfg)) + "&bodytext=" + encodeURIComponent(title);
                },
                pop_cfg: {
                    height: 300,
                    width: 700,
                    scrollbars: 0
                },
                getCount: function (cb, svc_cfg) {
                    $.ajax({
                        dataType: "jsonp",
                        url: "http://widgets.digg.com/buttons/count",
                        data: {
                            url: this._getUrlWithTracking(svc_cfg)
                        },
                        jsonp: "cb",
                        timeout: 3000,
                        success: function (response) {
                            cb(response.diggs);
                        }
                    });
                }
            }
        },

        /**
         * augment url with tracking params
         * @param {String} svc service name
         * @return {String} augmented url
         */
        _getUrlWithTracking: function (svc_cfg) {
            return (!svc_cfg.tracking) ? this.cfg.url : _appendQuery(this.cfg.url, $.extend(svc_cfg.tracking, this.cfg.tracking));

        },
        //


        /**
         *
         * @param {String} svc
         * @param {String} selector
         * @param {Object} cfg
         * @return {Social} instance, for chaining
         */
        bind: function (svc, selector, cfg) {
            // this is really lame -- needs to redo
            if ($(selector).hasClass("added")) {
                _resetVars();
            } else {
                $(selector).addClass("added");
            }

            cfg = $.extend(true, {}, this._services[svc].cfg, cfg);

            var that = this,
                $button = $(selector, this.cfg.container),
                showCounters = (typeof cfg.showCounters !== 'undefined') ? cfg.showCounters : this.cfg.showCounters,
                pop_cfg = $.extend(true, {}, this._services[svc].pop_cfg, cfg.pop_cfg),
                cb = function () {},
                gcFunc = function () {},
                oldthat = $.extend(true, {}, that),
                oldcfg = $.extend(true, {}, cfg);

            cfg.ourl = that._getUrlWithTracking(oldthat.cfg);
            cfg.urltracking = that._getUrlWithTracking(cfg);
            
            var url = this._services[svc].getUrl.call(this, cfg);
            cfg.twbaseurl  = url;
            
            if (svc === 'twitter') {  
               if (cfg.tweetTracking) {                
                 _addTweetTracking($button, cfg.tweetTracking);
              }
            }

            if (typeof this._services[svc].callafter !== 'undefined') {
                cb = (typeof this._services[svc].callafter === 'function') ? this._services[svc].callafter : this._services[svc].callafter[cfg.type];
            }

            if (typeof this._services[svc].getCount !== 'undefined') {
                gcFunc = (typeof this._services[svc].getCount === 'function') ? this._services[svc].getCount : this._services[svc].getCount[cfg.type];
            }

    
            
            if (showCounters && gcFunc) {
                
                if (!this.cfg.manuallyloading) {
                    $(document).ready(function () {
                        gcFunc.call(that, cb, cfg, $button);
                    });
                } else {
                    gcFunc.call(that, cb, cfg, $button);
                }
            }

            
            $button.on("click", function( e ) {                
                e.preventDefault();
                that.cfg.url = oldthat.cfg.url;
                cfg.tracking = oldcfg.tracking;
                url = that._services[svc].getUrl.call(that, cfg);
                
                if (cfg.omniture && typeof bam !== 'undefined' && (bam.tracking && bam.tracking.track)) {
                    bam.tracking.track(cfg.omniture);
                } else if (cfg.omniture && typeof fireTracking === 'function') {
                    if (cfg.omniture.pagename && cfg.omniture.sectionid) {
                        fireTracking(cfg.omniture.pagename, cfg.omniture.sectionid);
                    }
                } else if (cfg.omniture && (typeof Curveball !== 'undefined' && typeof Curveball.MobileTracking !== 'undefined' && typeof Curveball.MobileTracking.fireAsync !== 'undefined')) {
                    if (typeof Curveball.MobileTracking.fireAsync === 'function') {
                      Curveball.MobileTracking.fireAsync(cfg.omniture);
                    }
                }
                
                if (svc !== 'pinterest') {
                  _pop(that._services[svc].getUrl.call(that, cfg), pop_cfg);
                   return false;
                }
                
                
            });
            return this;
        }
    };

    var svc;
    for (svc in Social.prototype._services) {
        Social.prototype[svc] = (function (svc) {
            return function (selector, cfg) {
                return this.bind(svc, selector, cfg);
            };
        }(svc));
    }


    var doOminitureTracking = function (str) {
       
        var trackingVars = (typeof str !== 'object') ? $.parseJSON(str) : str;

        if (bam !== 'undefined' && (bam.tracking && bam.tracking.track)) {
            bam.tracking.track(trackingVars);
        } else if (trackingVars && typeof fireTracking === 'function') {
            if (trackingVars.pagename && trackingVars.sectionid) {
                fireTracking(trackingVars.pagename, trackingVars.sectionid);
            }
        }



    };
    
   

    var framesLoader = function (frames, pos) {
        pos = pos || 0;
        var frame = frames.eq(pos),
            fc = frames.length,
            url = frame.attr("data-url");

        if (pos < fc) {

            $(frame).one("load", function () {
                framesLoader(frames, ++pos);
            });

            $(frame).attr("src", url);

        } else {
            iframes_dfd.resolve();
        }



    };

    var loadGooglePlusOne = function (gp) {
        

        gapi.plusone.render(gp.attr("id"), {
            "size": gp.attr("data-size"),
            "annotation": gp.attr("data-annotation"),
            "width": gp.attr("data-width"),
            "href": gp.attr("data-href"),
            "callback": function () {
                if (gp.attr("data-omniture")) {
                    doOminitureTracking(gp.attr("data-omniture"));
                    
                }
            }

        });

    };

    var renderGooglePlusOne = function (gps, pos) {
        pos = pos || 0;

        var gp = gps.eq(pos),
            gl = gps.length;

        if (pos < gl) {
            gp.attr("id", "g-plusone-" + pos).removeClass("g-plusone-paused");
            loadGooglePlusOne(gp);
            pos++;
            renderGooglePlusOne(gps, pos);
        }

    };

    /**
     * Facebook Stuff
     */
    var bamFB = {

        feeds  : function(selector, cfg) {
        
        cfg = $.extend({
                url: document.location.href,
                headline: document.title,
                caption: undefined,
                desc: $("meta[name='description']").attr("content") || "",
                img: undefined,
                usr_msg: undefined,
                force_display: 'dialog',
                track_pfx: (window.omPageName || "Facebook UI") + ": ",
                success: undefined,
                error: undefined // callback function
            }, cfg);
            
            $(selector).unbind().bind("click", function () {
               
               $("html, body").animate({
                    scrollTop: 0
                }, "slow");

                if (cfg.track_pfx && typeof bam !== 'undefined' && (bam.tracking && bam.tracking.track)) {
                    bam.tracking.track({
                        genericExternalLinkTracker: {
                            tracked: cfg.track_pfx + 'Initial Click'
                        }
                    });
                }
              
                if (cfg.track_pfx && typeof fireTracking === 'function') {
                    fireTracking(cfg.track_pfx.pagename, cfg.track_pfx.sectionid);
                }
               
                if (cfg.track_pfx && (typeof Curveball !== 'undefined' && typeof Curveball.MobileTracking.fireAsync === 'function')) {
                    Curveball.MobileTracking.fireAsync(cfg.track_pfx);
                }
                
                FB.ui({
                     method: 'feed',
                     name: cfg.headline,
                     link: cfg.url,
                     picture: cfg.img,
                     caption: cfg.caption,
                     description:  cfg.desc
                   },
                   function(response) {
                     
                     if (response && response.post_id) {
                        cfg.track_pfx && bam.tracking && bam.tracking.track && bam.tracking.track({
                            genericExternalLinkTracker: {
                                tracked: cfg.track_pfx + 'Success Click'
                            }
                        });
                        (typeof cfg.success === "function") && cfg.success();
                    } else {
                        cfg.track_pfx && bam.tracking && bam.tracking.track && bam.tracking.track({
                            genericExternalLinkTracker: {
                                tracked: cfg.track_pfx + 'Cancel Click'
                            }
                        });
                        (typeof cfg.error === "function") && cfg.error();
                    }
                    
                   });


                
            });
        
        
        },
        
        publish: function (selector, cfg) {

            cfg = $.extend({
                url: document.location.href,
                headline: document.title,
                caption: undefined,
                desc: $("meta[name='description']").attr("content") || "",
                img: undefined,
                usr_msg: undefined,
                force_display: 'dialog',
                track_pfx: (window.omPageName || "Facebook UI") + ": ",
                success: undefined,
                // callback function
                error: undefined // callback function
            }, cfg);



            $(selector).unbind().bind("click", function () {
                $("html, body").animate({
                    scrollTop: 0
                }, "slow");

                if (cfg.track_pfx && typeof bam !== 'undefined' && (bam.tracking && bam.tracking.track)) {
                    bam.tracking.track({
                        genericExternalLinkTracker: {
                            tracked: cfg.track_pfx + 'Initial Click'
                        }
                    });
                }
                //wap
                if (cfg.track_pfx && typeof fireTracking === 'function') {
                    fireTracking(cfg.track_pfx.pagename, cfg.track_pfx.sectionid);
                }
                //mlbv2
                if (cfg.track_pfx && (typeof Curveball !== 'undefined' && typeof Curveball.MobileTracking.fireAsync === 'function')) {
                    Curveball.MobileTracking.fireAsync(cfg.track_pfx);
                }


                
                
                window.FB.ui({
                    method: 'stream.publish',
                    display: cfg.force_display,
                    message: cfg.usr_msg,
                    attachment: {
                        name: cfg.headline,
                        caption: cfg.caption,
                        description: cfg.desc,
                        href: cfg.url,
                        media: cfg.img && [{
                            type: "image",
                            href: cfg.url,
                            src: cfg.img
                        }]
                    }
                }, function (response) {
                    if (response && response.post_id) {
                        cfg.track_pfx && bam.tracking && bam.tracking.track && bam.tracking.track({
                            genericExternalLinkTracker: {
                                tracked: cfg.track_pfx + 'Success Click'
                            }
                        });
                        (typeof cfg.success === "function") && cfg.success();
                    } else {
                        cfg.track_pfx && bam.tracking && bam.tracking.track && bam.tracking.track({
                            genericExternalLinkTracker: {
                                tracked: cfg.track_pfx + 'Cancel Click'
                            }
                        });
                        (typeof cfg.error === "function") && cfg.error();
                    }
                });
                return false;
            });


            return this;
        }
    };

    bindable(bamFB);

    $.when(socialFb.init()).done(function (ajaxResult) {
        socialFb.event.subscribe('edge.create', function () {
            socialFb.trigger("FBLike");
        });
    });

    $.when.apply(null, df_queue).then(

        function () {

            $.when(iframes_dfd, gp_dfd).done(function () {
                renderGooglePlusOne($(".g-plusone-paused"));
            });

            if (queue.length > 0) {
                framesLoader($(queue.join()));
            } else {
                iframes_dfd.resolve();
            }

        });


    exports.Lib = Social;
    exports.FB = bamFB;
    exports.framesLoader = framesLoader;
    exports.renderGooglePlusOne = renderGooglePlusOne;
    exports.doOminitureTracking = doOminitureTracking;

});
